import { render, staticRenderFns } from "./fileSidebar.vue?vue&type=template&id=2e90820d&"
import script from "./fileSidebar.vue?vue&type=script&lang=js&"
export * from "./fileSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports